(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .controller("SideModalController", SideModalController);

    /** @ngInject */
    function SideModalController($uibModalInstance, content, MODAL_CONTENT_TYPES) {
        var vm = this;

        vm.contentTypes = MODAL_CONTENT_TYPES;
        vm.content = content;
        vm.isValid = true;
        vm.state = {
            submitLoading: false
        };

        vm.modalResponse = {};
        vm.modalMethods = {};

        vm.saveModalMethods = function (methods) {
            vm.modalMethods = methods;
        };

        vm.isFormInvalid = function () {
            if (vm.modalMethods.isFormInvalid) {
                return vm.modalMethods.isFormInvalid();
            }
        };


        vm.closeModal = function () {
            if (vm.modalMethods.closeModal) {
                vm.modalMethods.closeModal();
            }
            $uibModalInstance.dismiss();
        };

        vm.closeCustomerModal = function (customer) {
            $uibModalInstance.close(customer);
        };

        vm.closeSalesPointModal = function () {
            $uibModalInstance.dismiss();
        };

        vm.confirmModal = function (response) {
            if (vm.content.type === vm.contentTypes.CUSTOMER || vm.content.type === vm.contentTypes.SALES_POINT) {
                if (vm.modalMethods.save) {
                    vm.modalMethods.save();
                } else if (vm.modalMethods.submit) {
                    vm.modalMethods.submit();
                }
                return;
            }
            if (vm.modalMethods.applyFilters) {
                vm.modalMethods.applyFilters();
            }
            $uibModalInstance.close(vm.modalResponse);
        };
    }
})();
